import Spacings from "../../../../../../packages/design-system/src/Spacings/index.tsx";
import theme from "../../../../../../packages/design-system/src/designTokens.ts";
import Text from "../../../../../../packages/design-system/src/Text/index.tsx";
import * as React from 'react';
export default {
  Spacings,
  theme,
  Text,
  React
};